// 把一个问题交给「问问 AI」：ZeusAssistantHost 打开面板，并在助手就绪后转交给 xBIOS 助手页提交。
export const ZEUS_ASK_EVENT = 'gutdb-zeus-ask'
export const ZEUS_ASK_MESSAGE = 'gutdb_assistant_ask'
